import * as types from '../mutation-types';

// state
export const state = {
  width: window.innerWidth,
};

// getters
export const getters = {
  width: (state) => state.width,
};

// mutations
export const mutations = {
  [types.SET_WIDTH](state, { width }) {
    state.width = width;
  },
};

// actions
export const actions = {
  setWidth({ commit }) {
    commit(types.SET_WIDTH, { width: window.innerWidth });
  },
};
